<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(handlSaveAddress)">
        <div class="form">
          <ValidationProvider name="country" rules="required|min:2" v-slot="{ errors }" slim>
            <SfSelect v-if="countries" v-e2e="'shipping-country'" v-model="address.country" :label="$t('Country')"
              name="country" class="form__element form__element--half form__select sf-select--underlined" required
              :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })" @input="($event)=>changeCounry($event)">
              <SfSelectOption v-for="countryOption in countries" :key="countryOption.key"
                :value="countryOption.simple_speech">
                {{ $t(countryOption.simple_speech) }}
              </SfSelectOption>
            </SfSelect>
          </ValidationProvider>
          <ValidationProvider name="state" rules="required" v-slot="{ errors }" slim>
            <!-- <SfInput v-e2e="'shipping-state'" v-model="address.state" :label="$t('MyAccount_MyShippingDetails_State')"
              name="state" class="form__element form__element--half form__element--half-even" required :valid="!errors[0]"
                :errorMessage="$t(errors[0])" /> -->
            <SfSelect v-e2e="'shipping-state'" v-model="address.state" :label="$t('MyAccount_MyShippingDetails_State')"
              name="state" class="form__element form__element--half form__select sf-select--underlined" required
              :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })">
              <SfSelectOption v-if="provinces" v-for="province in provinces" :key="province.id"
                :value="province.countries_library_nodes_name">
                {{ province.countries_library_nodes_name }}
              </SfSelectOption>
            </SfSelect>
          </ValidationProvider>
          <ValidationProvider v-if="address.country !== 'JP'" name="city" rules="required" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-city'" v-model="address.city" :label="$t('MyAccount_MyShippingDetails_City')"
              name="city" class="form__element form__element--half" required :valid="!errors[0]"
              :errorMessage="$t(errors[0])" />
          </ValidationProvider>
          <ValidationProvider name="streetName" rules="required" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-streetName'" v-model="address.streetName"
              :label="address.country !== 'JP' ? $t('MyAccount_MyShippingDetails_Street') : $t('Shipping_details')"
              name="streetName" class="form__element form__element--half" required :valid="!errors[0]"
              :errorMessage="$t(errors[0])" />
          </ValidationProvider>
          <ValidationProvider v-if="address.country !=='JP'" name="apartment" rules="required" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-apartment'" v-model="address.apartment"
              :label="$t('MyAccount_MyShippingDetails_HouseNumber')" name="apartment"
              class="form__element form__element--half" required :valid="!errors[0]" :errorMessage="$t(errors[0])" />
          </ValidationProvider>
          <ValidationProvider name="zipCode" rules="required|min:2" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-zipcode'" v-model="address.zipCode" :label="$t('MyAccount_MyShippingDetails_Zip')"
              name="zipCode" class="form__element form__element--half " required :valid="!errors[0]"
              :errorMessage="$t(errors[0], { min: 2 })" />
          </ValidationProvider>
          <ValidationProvider v-if="address.country !== 'JP'" name="firstName" rules="required|min:1"
            v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-firstName'" v-model="address.firstName"
              :label="$t('MyAccount_MyShippingDetails_First')" name="firstName"
              class="form__element form__element--half" required :valid="!errors[0]"
              :errorMessage="$t(errors[0], { min: 1 })" />
          </ValidationProvider>
          <ValidationProvider name="lastName" rules="required|min:1" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-lastName'" v-model="address.lastName"
              :label="address.country !== 'JP' ? $t('MyAccount_MyShippingDetails_Last') : $t('order_shopping_firstname')"
              name="lastName" class="form__element form__element--half " required
              :class="{ 'form__element--half-even': address.country !== 'JP' }" :valid="!errors[0]"
              :errorMessage="$t(errors[0], { min: 1 })" />
          </ValidationProvider>
          <ValidationProvider name="phoneNumber" rules="required|precision" v-slot="{ errors }" slim>
            <SfInput v-e2e="'shipping-phone'" v-model="address.phoneNumber"
              :label="$t('MyAccount_MyShippingDetails_Phone')" name="phoneNumber"
              class="form__element form__element--half " required :valid="!errors[0]" :errorMessage="$t(errors[0])" />
          </ValidationProvider>

          <div class="form__action add_shipping_link">
            <SfButton :disabled="loading" class="form__action-button" type="submit">
              {{ $t('Save') }}
            </SfButton>

            <SfButton class="form__action-button2" @click="elimtCancle" type="button">
              {{ $t('Cancel') }}
            </SfButton>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  SfTabs,
  SfInput,
  SfButton,
  SfSelect,
  SfComponentSelect,
  SfIcon
} from '@storefront-ui/vue';
// import VueI18n from 'vue-i18n';
import { ref, onMounted } from '@nuxtjs/composition-api';
import { useShipping, useGuoJia, useApiError, useProvince } from '@bee-hole/coms';
import { required, min } from 'vee-validate/dist/rules';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});
extend('min', {
  ...min,
  message: 'Shipping_valid_length_min'
});

extend('precision', {
  validate: value => {
    const precision = value.toString()?.length || 0;
    return precision >= 4;
  },
  message: 'Shipping_valid_Phone'
});
export default {
  name: 'ShippingAddressForm',
  components: {
    SfTabs,
    SfInput,
    SfButton,
    SfSelect,
    SfComponentSelect,
    SfIcon,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    addressInput: {}
  },
  setup(pros, context) {
    const { getProvince, result: provinceList } = useProvince();
    const { emit, root } = context;
    const address = ref({
      firstName: '',
      lastName: '',
      streetName: '',
      apartment: '',
      city: '',
      state: '',
      country: null,
      postalCode: '',
      phoneNumber: null,
      zipCode: ''
    });
    const loading = ref(false);
    const COUNTRIES = ref();
    const { set: setError } = useApiError();
    const { load } = useShipping();
    const { GuoJiaGet, result: countryList } = useGuoJia();
    const provinces = ref();
    // 发出保存成功事件
    const elimtSave = (addressId) => {
      emit('save', { result: 'ok', addressId });
    };

    // 发出取消事件
    const elimtCancle = () => {
      emit('cancle', { result: 'ok' });
    };

    // 保存地址
    const handlSaveAddress = async () => {
      loading.value = true;
      root.$vsf.$xbuy.api.customUpdateaddress(address.value).then(async (res) => {
        loading.value = false;
        if (res?.code === 0) {
          await load();
          elimtSave(res?.data?.address_id);
        } else {
          setError(res);
        }
      });
      // elimtSave();
    };
    const changeCounry = async (value) => {
      // address.value.country = value;
      await getProvince({ country_code: value });
      provinces.value = provinceList.value?.list;
      address.value.state = provinces.value[0]?.countries_library_nodes_name;
    };
    onMounted(async () => {
      await GuoJiaGet();
      COUNTRIES.value = countryList.value;
      address.value.country = countryList.value?.[0]?.simple_speech;
      if (address.value.country) {
        changeCounry(address.value.country);
      }
    });
    return {
      elimtSave,
      elimtCancle,
      handlSaveAddress,
      address,
      countries: COUNTRIES,
      loading,
      changeCounry,
      provinces
    };
  }
};
</script>

<style lang="scss" scoped>
.form {
  --button-width: 100%;

  &__select {
    display: flex;
    align-items: center;
    --select-option-font-size: var(--font-size--lg);

    ::v-deep .sf-select__dropdown {
      font-size: var(--font-size--lg);
      margin: 0;
      color: var(--c-text);
      font-family: var(--font-family--secondary);
      font-weight: var(--font-weight--normal);
    }
  }

  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    --button-width: auto;
  }

  &__element {
    margin: 0 0 var(--spacer-xl) 0;

    @include for-desktop {
      flex: 0 0 100%;
    }

    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }

      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-xl);
        }
      }
    }
  }

  &__action {
    @include for-desktop {
      flex: 0 0 100%;
      display: flex;
    }
  }

  &__action-button {
    @media (max-width: 1023px) {
      margin-bottom: var(--spacer-lg);
    }

    &--secondary {
      @include for-desktop {
        order: -1;
        text-align: left;
      }
    }

    &--add-address {
      width: 100%;
      margin: 0;

      @include for-desktop {
        margin: 0 0 var(--spacer-lg) 0;
        width: auto;
      }
    }
  }

  &__action-button2 {
    @media (max-width: 1023px) {
      margin-left: 0;
      margin-bottom: var(--spacer-lg);
    }

    @media (min-width: 1024px) {
      margin-left: 20px;
    }

    // &--secondary {
    //   @include for-desktop {
    //     order: -1;
    //     text-align: left;
    //   }
    // }
    // &--add-address {
    //   width: 100%;
    //   margin: 0;
    //   @include for-desktop {
    //     margin: 0 0 var(--spacer-lg) 0;
    //     width: auto;
    //   }
    // }
  }

  &__back-button {
    margin: var(--spacer-xl) 0 var(--spacer-sm);

    &:hover {
      color: var(--c-white);
    }

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
    }
  }
}
</style>
